import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { FiMoon, FiSun } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { toggleDarkMode } from '../store/slices/uiSlice';

const AuthLayout: React.FC = () => {
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);
    const { darkMode } = useSelector((state: RootState) => state.ui);
    const dispatch = useDispatch();

    // If user is already authenticated, redirect to dashboard
    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    const handleToggleDarkMode = () => {
        dispatch(toggleDarkMode());
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
            {/* Header with dark mode toggle */}
            <header className="bg-white dark:bg-gray-800 shadow-sm p-4 flex justify-end">
                <button
                    className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
                    onClick={handleToggleDarkMode}
                >
                    {darkMode ? (
                        <FiSun className="w-6 h-6" />
                    ) : (
                        <FiMoon className="w-6 h-6" />
                    )}
                </button>
            </header>

            <div className="flex-1 flex items-center justify-center">
                <div className="max-w-md w-full mx-auto p-6">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-primary-600 dark:text-primary-400">
                            Tenant Manager
                        </h1>
                        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                            Manage your multi-tenant application with ease
                        </p>
                    </div>

                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
                        <Outlet />
                    </div>
                </div>
            </div>

            <footer className="py-4 text-center text-sm text-gray-500 dark:text-gray-400">
                &copy; {new Date().getFullYear()} Tenant Manager. All rights reserved.
            </footer>
        </div>
    );
};

export default AuthLayout;